import { render } from "./Logo.vue?vue&type=template&id=1124f5f1&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=1124f5f1&scoped=true&lang=scss"

import exportComponent from "/Users/leonardomarsigli/code/LeoMarseo/personal-projects/dirtysocks-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1124f5f1"]])

export default __exports__